export default __webpack_public_path__ + "static/img-worries_people2_sp-0451fdbd1b901150df6a8c0e429d36e0.svg";